import TableLayout from 'element-ui/packages/table/src/table-layout'

// 修改TableLayout类，设置gutter为6
class ExtTableLayout extends TableLayout {
  constructor() {
    super(...arguments)
    this.gutterWidth = 6
  }
}

// 通过装饰器方式重写el-table组件的data函数，用修改过的TableLayout类实例替换原layout属性
export default function modifyTable(ElementUI) {
  const tableDataFunc = ElementUI.Table.data
  ElementUI.Table.data = function () {
    const _this = this
    const data = tableDataFunc.call(_this)
    data.layout = new ExtTableLayout({
      store: _this.store,
      table: _this,
      fit: _this.fit,
      showHeader: _this.showHeader
    })
    return data
  }
}
